import { RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

export default function LiveBadge({ refreshing, lastUpdated, onRefresh }) {
  const time = lastUpdated
    ? new Date(lastUpdated).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit", second: "2-digit" })
    : "—";
  return (
    <div className="flex items-center gap-3" data-testid="live-badge">
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
        En direct
      </span>
      <span className="text-xs text-slate-400" data-testid="live-updated-at">Mis à jour à {time}</span>
      {onRefresh && (
        <button data-testid="live-refresh-btn" onClick={onRefresh} title="Actualiser maintenant"
          className="p-1.5 rounded-lg text-slate-400 hover:text-indigo-600 hover:bg-slate-100 transition-colors">
          <RefreshCw size={15} className={cn(refreshing && "animate-spin")} />
        </button>
      )}
    </div>
  );
}
